<main>
  <div class="container" id="main-container">
    <div class="row">
      <div class="col px-lg-4">
        <app-breadcrumbs [path]="data?.path?.alias" [title]="data?.title"></app-breadcrumbs>
      </div>
    </div>
    <div class="row" *ngIf="data.moderation_state == 'archived'">
      <div class="col px-lg-4">
        <div class="callout danger">
          <div class="callout-inner">
            <div class="callout-title">
              <svg class="icon">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
              </svg>
              <span class="visually-hidden">Note</span>
              <span class="text">Contenuto archiviato</span>
            </div>
            <p><span class="node__archived_text">Contenuto archiviato per fini storici di documentazione.</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 px-lg-4 py-lg-2">
        <h1 data-audio="">
          {{ data.title }}
        </h1>
        <h3 class="visually-hidden">Dettagli del documento</h3>
        <p data-audio="">
          {{ data.public_document_short_desc }}
        </p>
        <p>
          {{ data?.public_document_protocol }} <span *ngIf="data.public_document_protocol">-</span>
          {{ data?.public_document_protocol_date | date }}
        </p>
      </div>
      <div class="col-lg-3 offset-lg-1">
        <app-social-share [url]="data?.path?.alias"></app-social-share>
        <app-actions-list [mailObject]="data?.title" [path]="data?.path?.alias"></app-actions-list>
        <div class="mt-4 mb-4" *ngIf="data?.public_document_tags?.length > 0">
          <div class="row">
            <span class="mb-2 small">Argomenti</span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let tag of data?.public_document_tags">
              <a class="chip chip-simple" [href]="tag?.path?.alias">
                <span class="chip-label">{{ tag.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="mt-4 mb-4">
          <div class="row">
            <span class="mb-2 small">Tipologia di documento </span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li>
              <span class="chip chip-simple" style="cursor: default">
                <span class="chip-label">{{ data?.public_document_type?.name }}</span>
              </span>
            </li>
          </ul>
        </div>
        <div class="mt-4 mb-4" *ngIf="data?.field_objectives?.length > 0">
          <div class="row">
            <span class="mb-2 small"><i>Questo contenuto contribuisce agli obiettivi di sviluppo
                sostenibile:</i></span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let objective of data?.field_objectives">
              <img [src]="objective?.field_icona?.uri?.url" [title]="objective?.name" [alt]="objective?.name"
                class="icon icon-lg" />
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
  <div class="container-fluid my-3" *ngIf="data.field_internal_image?.field_media_image">
    <div class="row">
      <figure class="figure px-0 img-full">
        <img [src]="data.field_internal_image?.field_media_image?.uri?.url" class="figure-img img-fluid"
          [alt]="data.field_internal_image?.field_media_image?.meta?.alt" />
        <figcaption class="figure-caption text-center pt-3">
          {{ data.field_internal_image?.field_media_image?.meta?.title }} <span
            *ngIf="data?.field_internal_image?.field_media_licence"> -
            {{data.field_internal_image?.field_media_licence}}</span>
        </figcaption>
      </figure>
    </div>
  </div>
  <div class="container">
    <div class="row border-top border-light row-column-border row-column-menu-left">
      <aside class="col-lg-3">
        <div class="cmp-navscroll sticky-top" aria-labelledby="accordion-title-one">
          <nav class="navbar it-navscroll-wrapper navbar-expand-lg" aria-label="INDICE DELLA PAGINA"
            data-bs-navscroll="">
            <div class="navbar-custom" id="navbarNavProgress">
              <div class="menu-wrapper">
                <div class="link-list-wrapper">
                  <div class="accordion">
                    <div class="accordion-item">
                      <span class="accordion-header" id="accordion-title-one">
                        <button class="accordion-button pb-10 px-3" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapse-one" aria-expanded="true" aria-controls="collapse-one">
                          INDICE DELLA PAGINA
                          <svg class="icon icon-xs right" aria-label="Accordion">
                            <use href="bootstrap-italia/dist/svg/sprites.svg#it-expand"></use>
                          </svg>
                        </button>
                      </span>
                      <div class="progress">
                        <div class="progress-bar it-navscroll-progressbar" role="progressbar" aria-valuenow="0"
                          aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div>
                      </div>
                      <div id="collapse-one" class="accordion-collapse collapse show" role="region"
                        aria-labelledby="accordion-title-one">
                        <div class="accordion-body">
                          <ul class="link-list" data-element="page-index">
                            <li class="nav-item">
                              <a class="nav-link active" href="#" data-focus-mouse="false"
                                (click)="scrollTo('descrizione')">
                                <span class="title-medium">Descrizione</span>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#" data-focus-mouse="false" (click)="scrollTo('documento')">
                                <span class="title-medium">{{ data?.field_documenti?.length >= 2 ? 'Documenti' :
                                  'Documento' }}</span>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#" data-focus-mouse="false" (click)="scrollTo('licence')">
                                <span class="title-medium">Licenza di distribuzione</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngIf="data?.public_document_fmts">
                              <a class="nav-link" href="#" data-focus-mouse="false" (click)="scrollTo('formats')">
                                <span class="title-medium">Formati disponibili</span>
                              </a>
                            </li>
                            <ng-container *ngFor="let link of links">
                              <li class="nav-item">
                                <a class="nav-link" href="#" data-focus-mouse="false" (click)="scrollTo(link.url)">
                                  <span class="title-medium">{{
                                    link.title
                                    }}</span>
                                </a>
                              </li>
                            </ng-container>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </aside>
      <section class="col-lg-9 it-page-sections-container border-light">
        <article id="descrizione" class="it-page-section anchor-offset richtext-wrapper" data-audio="">
          <h3 class="mt-4 mb-4 font-sans-serif" *ngIf="data?.public_document_body?.processed">
            Descrizione
          </h3>
          <p [innerHTML]="data?.public_document_body?.processed || '' | safeHtml"></p>
        </article>
        <article id="documento" class="it-page-section anchor-offset richtext-wrapper" data-audio="">
          <h3 class="mt-4 mb-4 font-sans-serif">
            {{ data?.field_documenti?.length >= 2 ? 'Documenti' : 'Documento' }}
          </h3>
          <div class="row">
            <div class="col-10">
              <ng-container *ngFor="let doc of data?.field_documenti">
                <div class="card card-teaser rounded shadow mb-15">
                  <div class="card-body">
                    <div class="it-list-wrapper">
                      <ul class="it-list">
                        <li>
                          <div class="list-item">
                            <div class="it-right-zone">
                              <span class="text">{{
                                doc?.fname || "Documento"
                                }}</span>
                              <span class="it-multiple">
                                <a [href]="doc.furi" *ngIf="doc?.furi" target="_blank">
                                  <svg class="icon icon-primary" aria-label="Dowload">
                                    <use href="/bootstrap-italia/dist/svg/sprites.svg#it-download"></use>
                                  </svg>
                                </a>
                                <a [href]="doc?.furl" *ngIf="doc?.furl" target="_blank">
                                  <svg class="icon icon-primary" aria-label="Link esterno">
                                    <use href="/bootstrap-italia/dist/svg/sprites.svg#it-external-link"></use>
                                  </svg>
                                </a>
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </article>
        <article id="formats" class="it-page-section anchor-offset richtext-wrapper" data-audio=""
          *ngIf="data?.public_document_fmts">
          <h3 class="mt-4 mb-4 font-sans-serif">Formati disponibili</h3>
          <p [innerHTML]="data?.public_document_fmts?.processed || '' | safeHtml"></p>
        </article>
        <article id="licence" class="it-page-section anchor-offset richtext-wrapper" data-audio="">
          <h3 class="mt-4 mb-4 font-sans-serif">Licenza di distribuzione</h3>
          <span class="chip chip-simple" style="cursor: default">
            <span class="chip-label">{{
              data?.public_document_license?.name
              }}</span>
          </span>
        </article>
        <article id="office" class="it-page-section anchor-offset richtext-wrapper">
          <h3 class="mt-4 mb-4 font-sans-serif" *ngIf="data?.public_document_office?.length < 2">
            Ufficio responsabile del documento
          </h3>
          <h3 class="mt-4 mb-4 font-sans-serif" *ngIf="data?.public_document_office?.length >=2">
            Uffici responsabili del documento
          </h3>
          <div class="card-wrapper card-teaser-wrapper">
            <div class="card card-teaser card-teaser-info shadow-sm mt-3 rounded"
              *ngFor="let office of data?.public_document_office">
              <div class="card-body">
                <h3 class="card-title h5">
                  <a [href]="office?.path?.alias" class="text-decoration-none">
                    {{ office?.title }}
                  </a>
                </h3>
                <div class="card-text">
                  <p>{{office?.org_unit_headquarters?.place_address}}</p>
                </div>
              </div>
              <div class="avatar bg-white size-xl">
                <svg class="icon" aria-hidden="true" aria-label="Pubblica amministrazione">
                  <use href="bootstrap-italia/dist/svg/sprites.svg#it-pa"></use>
                </svg>
              </div>
            </div>
          </div>
        </article>
      </section>
    </div>
  </div>
</main>